import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  vehicleTypes: [],
  selectedVehicleType: null,
  loading: false,
  error: null,
  successMessage: null,
  // Pagination
  page: 1,
  pageSize: 10,
  total: 0,
  // Sorting
  sortColumn: 'name',
  sortDirection: 'asc',
  // Filtering
  filterName: '',
};

const vehicleTypesSlice = createSlice({
  name: 'vehicleTypes',
  initialState,
  reducers: {
    // Fetch vehicle types
    fetchVehicleTypes: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVehicleTypesSuccess: (state, action) => {
      state.loading = false;
      state.vehicleTypes = action.payload.data;
      state.total = action.payload.meta.total;
      state.error = null;
    },
    fetchVehicleTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Fetch vehicle type by ID
    fetchVehicleTypeById: (state) => {
      state.loading = true;
      state.error = null;
    },
    fetchVehicleTypeByIdSuccess: (state, action) => {
      state.loading = false;
      state.selectedVehicleType = action.payload;
      state.error = null;
    },
    fetchVehicleTypeByIdFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Add vehicle type
    addVehicleType: (state) => {
      state.loading = true;
      state.error = null;
    },
    addVehicleTypeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    addVehicleTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Update vehicle type
    updateVehicleType: (state) => {
      state.loading = true;
      state.error = null;
    },
    updateVehicleTypeSuccess: (state, action) => {
      state.loading = false;
      state.successMessage = action.payload.message;
      state.error = null;
    },
    updateVehicleTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Delete vehicle type
    deleteVehicleType: (state) => {
      state.loading = true;
      state.error = null;
    },
    deleteVehicleTypeSuccess: (state, action) => {
      state.loading = false;
      state.vehicleTypes = state.vehicleTypes.filter((vt) => vt.id !== action.payload);
      state.error = null;
      state.successMessage = action.payload.message;
    },
    deleteVehicleTypeFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Bulk delete
    bulkDeleteVehicleTypes: (state) => {
      state.loading = true;
      state.error = null;
    },
    bulkDeleteVehicleTypesSuccess: (state, action) => {
      state.loading = false;
      state.vehicleTypes = state.vehicleTypes.filter((vt) => !action.payload.includes(vt.id));
      state.error = null;
      state.successMessage = action.payload.message;
    },
    bulkDeleteVehicleTypesFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },

    // Pagination
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
      state.page = 1;
    },

    // Sorting
    setSortColumn: (state, action) => {
      state.sortColumn = action.payload;
    },
    setSortDirection: (state, action) => {
      state.sortDirection = action.payload;
    },

    // Filtering
    setFilterName: (state, action) => {
      state.filterName = action.payload;
      state.page = 1;
    },

    // Clear messages
    clearError: (state) => {
      state.error = null;
    },
    clearSuccessMessage: (state) => {
      state.successMessage = null;
    },
  },
});

export const {
  fetchVehicleTypes,
  fetchVehicleTypesSuccess,
  fetchVehicleTypesFailure,
  fetchVehicleTypeById,
  fetchVehicleTypeByIdSuccess,
  fetchVehicleTypeByIdFailure,
  addVehicleType,
  addVehicleTypeSuccess,
  addVehicleTypeFailure,
  updateVehicleType,
  updateVehicleTypeSuccess,
  updateVehicleTypeFailure,
  deleteVehicleType,
  deleteVehicleTypeSuccess,
  deleteVehicleTypeFailure,
  bulkDeleteVehicleTypes,
  bulkDeleteVehicleTypesSuccess,
  bulkDeleteVehicleTypesFailure,
  setPage,
  setPageSize,
  setSortColumn,
  setSortDirection,
  setFilterName,
  clearError,
  clearSuccessMessage,
} = vehicleTypesSlice.actions;

// Selectors
export const selectVehicleTypes = (state) => state.vehicleTypes?.vehicleTypes || [];
export const selectSelectedVehicleType = (state) => state.vehicleTypes?.selectedVehicleType;
export const selectVehicleTypesLoading = (state) => state.vehicleTypes?.loading || false;
export const selectVehicleTypesError = (state) => state.vehicleTypes?.error;
export const selectVehicleTypesSuccessMessage = (state) => state.vehicleTypes?.successMessage;
export const selectVehicleTypesTotal = (state) => state.vehicleTypes?.total || 0;
export const selectVehicleTypesPage = (state) => state.vehicleTypes?.page || 1;
export const selectVehicleTypesPageSize = (state) => state.vehicleTypes?.pageSize || 10;
export const selectVehicleTypesSortColumn = (state) => state.vehicleTypes?.sortColumn || 'name';
export const selectVehicleTypesSortDirection = (state) => state.vehicleTypes?.sortDirection || 'asc';
export const selectVehicleTypesFilterName = (state) => state.vehicleTypes?.filterName || '';

export default vehicleTypesSlice.reducer;
